import React, { useEffect } from "react";
import "./style/App.scss";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
import { Router } from "./Routes";
import { onRefreshToken } from "./utils/TokenUtils";
import { getToken } from "./utils/LocalStorageHelper";
import {
  axiosErrorHandler,
  axiosResponseHandler,
  checkToken,
} from "./utils/AxiosHandlers";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TourProvider } from "./context/TourContext";

export const axiosPredsenseInstance = axios.create({
  baseURL: "https://api.predsense.ai/predsense",
});

export const axiosUploaderInstance = axios.create({
  baseURL: "https://api.predsense.ai/data",
});

function App() {
  useEffect(() => {
    const intervalId = setInterval(() => {
      !document.hidden && onRefreshToken();
    }, 5000);
    return () => {
      clearInterval(intervalId!);
    };
  }, []);

  const configureInterceptor = (axiosInstance: typeof axiosPredsenseInstance) => {
    axiosInstance.interceptors.request.use(
      // @ts-ignore
      (config) => {
        if (config.headers?.skipTokenCheck) {
          return config;
        }

        const token = config.headers?.token ? config.headers.token : getToken();
        return checkToken(
          config,
          token as string,
          () => {},
          () => {
            config.headers!.Authorization = `Bearer ${token}`;
            return config;
          }
        );
      },
      (error) => {
        console.log("error: ", error);
        return Promise.reject(error);
      }
    );

    axiosInstance.interceptors.response.use(
      axiosResponseHandler,
      axiosErrorHandler
    );
  };

  configureInterceptor(axiosPredsenseInstance);
  configureInterceptor(axiosUploaderInstance);

  return (
    <TourProvider>
      <BrowserRouter basename="/">
        <Router />
      </BrowserRouter>
      <ToastContainer theme="colored" />
    </TourProvider>
  );
}

export default App;
